// extracted by mini-css-extract-plugin
export default {"card":"UsageCard_card__98rA0","header":"UsageCard_header__nkNqK","text":"UsageCard_text__q7BTZ","active":"UsageCard_active__ZexjM"};